import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Orders-index-1992f2b810f284983-1'),
    routerUrl: '/Orders',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Orders')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Orders-index-1992f2b810f284983-2'),
        routerUrl: '/OrdersForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./OrdersForm')),
      },
      //$MORE$
    ],
  },
];
